import { render, staticRenderFns } from "./FaqCollapse.vue?vue&type=template&id=62a25576"
import script from "./FaqCollapse.vue?vue&type=script&lang=js"
export * from "./FaqCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports